import { render } from "./TrustedCompanyBadge.vue?vue&type=template&id=fedf297a&scoped=true"
import script from "./TrustedCompanyBadge.vue?vue&type=script&lang=js"
export * from "./TrustedCompanyBadge.vue?vue&type=script&lang=js"

import "./TrustedCompanyBadge.vue?vue&type=style&index=0&id=fedf297a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fedf297a"]])

export default __exports__